module.exports = __webpack_public_path__ + "static/img/logo@2x.08ae915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180102/logo@2x.png
// module id = 252
// module chunks = 1